import builderPathInit from '../../util/builder-path-init';

const { BuilderPage, getServerSideProps } = builderPathInit({
  model: 'education-page',
  pathPrefix: 'educators',
});

export default BuilderPage;
export { getServerSideProps };
